import { batch } from '@tmapy/redux';
import { INTERACTION_KIND, INTERACTION, LAYER_IDS } from '@tmapy/config';
import { INTERACTION_DRAW_FEATURES, actionInteractionSelectFeatures, geoJSONToFeature, actionMergeLayers, SET_INTERACTION, INTERACTION_MODIFY_FEATURES, } from '@tmapy/mapcore';
import { actionSetNotesState } from '../actions';
export const notesMiddleware = (store) => (next) => (action) => {
    return batch(() => {
        const originalAction = next(action);
        switch (action.type) {
            case SET_INTERACTION:
                if ((action.payload.type === INTERACTION.SELECT_MODIFY &&
                    action.payload.layerId === LAYER_IDS.NOTES) ||
                    (action.payload.type === INTERACTION.DRAW &&
                        action.payload.layerId === LAYER_IDS.NOTES_MODIFY)) {
                    store.dispatch(actionMergeLayers({
                        fromLayerId: LAYER_IDS.NOTES_MODIFY,
                        toLayerId: LAYER_IDS.NOTES,
                    }));
                    store.dispatch(actionInteractionSelectFeatures(LAYER_IDS.NOTES, []));
                }
                break;
            case INTERACTION_DRAW_FEATURES: {
                if (action.payload.layerId === LAYER_IDS.NOTES_MODIFY) {
                    const olFeatures = action.payload.features.map((feature) => geoJSONToFeature(feature));
                    switch (action.payload.kind) {
                        case INTERACTION_KIND.DRAW_START: {
                            store.dispatch(actionMergeLayers({
                                fromLayerId: LAYER_IDS.NOTES_MODIFY,
                                toLayerId: LAYER_IDS.NOTES,
                            }));
                            break;
                        }
                        case INTERACTION_KIND.MODIFY_END:
                        case INTERACTION_KIND.DRAW_END: {
                            store.dispatch(actionInteractionSelectFeatures(action.payload.layerId, olFeatures));
                            store.dispatch(actionSetNotesState({ isChanged: true }));
                            break;
                        }
                    }
                }
                return originalAction;
            }
            case INTERACTION_MODIFY_FEATURES: {
                if (action.payload.layerId === LAYER_IDS.NOTES) {
                    store.dispatch(actionSetNotesState({ isChanged: true }));
                }
                return originalAction;
            }
            default: {
                return originalAction;
            }
        }
    });
};
//# sourceMappingURL=notesMiddleware.js.map